import { useEffect, useState } from "react";
import { MessageSquare, Bot, User, CheckCircle2, Loader2, Inbox } from "lucide-react";
import api from "@/lib/api";
import DashLayout from "@/components/xuma/DashLayout";

const fmt = (iso) => { try { return new Date(iso).toLocaleString("es-MX", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }); } catch { return ""; } };

export default function Conversations() {
  const [convos, setConvos] = useState(null);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/conversations").then(({ data }) => { setConvos(data); if (data[0]) setActive(data[0].session_id); }).catch(() => setConvos([]));
  }, []);

  if (convos === null) {
    return <DashLayout title="Conversaciones"><div className="grid place-items-center py-20"><Loader2 className="h-8 w-8 animate-spin text-xuma-primary" /></div></DashLayout>;
  }

  if (convos.length === 0) {
    return (
      <DashLayout title="Conversaciones">
        <div className="rounded-3xl bg-white border border-xuma-border p-12 text-center">
          <Inbox className="h-10 w-10 mx-auto text-xuma-muted" />
          <h3 className="mt-4 font-heading font-bold text-xl text-xuma-dark">Aún no hay conversaciones</h3>
          <p className="mt-2 text-sm text-xuma-muted">Cuando alguien chatee con tu asistente, verás el historial aquí.</p>
        </div>
      </DashLayout>
    );
  }

  const current = convos.find((c) => c.session_id === active);

  return (
    <DashLayout title="Conversaciones">
      <div className="grid md:grid-cols-3 gap-5">
        <div className="space-y-2">
          {convos.map((c) => (
            <button key={c.session_id} data-testid={`convo-${c.session_id}`} onClick={() => setActive(c.session_id)}
              className={`w-full text-left rounded-2xl border p-4 transition-colors ${active === c.session_id ? "border-xuma-primary bg-white" : "border-xuma-border bg-white hover:border-xuma-primary/40"}`}>
              <div className="flex items-center justify-between">
                <span className="flex items-center gap-2 text-sm font-medium text-xuma-dark"><MessageSquare className="h-4 w-4 text-xuma-primary" /> {(c.messages?.length || 0)} mensajes</span>
                {c.lead_saved && <CheckCircle2 className="h-4 w-4 text-green-600" />}
              </div>
              <p className="text-xs text-xuma-muted mt-1 truncate">{c.messages?.[c.messages.length - 1]?.content || ""}</p>
              <p className="text-[11px] text-xuma-muted mt-1">{fmt(c.updated_at || c.created_at)}</p>
            </button>
          ))}
        </div>

        <div className="md:col-span-2 rounded-2xl bg-white border border-xuma-border p-5">
          {current ? (
            <div className="space-y-3">
              {current.lead_saved && (
                <div className="rounded-xl bg-green-50 text-green-700 text-sm px-4 py-2 flex items-center gap-2"><CheckCircle2 className="h-4 w-4" /> Prospecto captado en tu CRM</div>
              )}
              {(current.messages || []).map((m, i) => (
                <div key={i} className={`flex gap-2 ${m.role === "user" ? "justify-end" : "justify-start"}`}>
                  {m.role === "assistant" && <span className="h-7 w-7 rounded-full bg-xuma-primary grid place-items-center text-white shrink-0"><Bot className="h-3.5 w-3.5" /></span>}
                  <div className={`max-w-[80%] rounded-2xl px-4 py-2 text-sm whitespace-pre-line ${m.role === "user" ? "bg-xuma-primary text-white rounded-tr-sm" : "bg-xuma-bg text-xuma-dark rounded-tl-sm"}`}>{m.content}</div>
                  {m.role === "user" && <span className="h-7 w-7 rounded-full bg-xuma-dash grid place-items-center text-xuma-muted shrink-0"><User className="h-3.5 w-3.5" /></span>}
                </div>
              ))}
            </div>
          ) : <p className="text-sm text-xuma-muted">Selecciona una conversación.</p>}
        </div>
      </div>
    </DashLayout>
  );
}
